import { useFormikContext } from 'formik';

import { FormikInput } from '../../../../cdl/Input/FormikInput';
import { ReadOnlyField } from '../../../../cdl/ReadOnlyField/ReadOnlyField';
import { Text } from '../../../../cdl/Text/Text';
import { translate } from '../../../../common/helpers/translate.helper';
import { useRole } from '../../../../common/hooks/useRole';
import { Box } from '../../../../common/ui/Box';
import { FormikVesselDefaultSupplierFlow } from '../../../FormikVesselDefaultSupplierFlow';
import { FormikVesselDetailsState } from '../EditVesselForm';

interface FormikVesselDetailsSectionProps {
    customerId: string;
    vesselId: string;
}

export const FormikVesselDetailsSection = ({ customerId, vesselId }: FormikVesselDetailsSectionProps) => {
    const { values } = useFormikContext<FormikVesselDetailsState>();
    const role = useRole();

    return (
        <>
            <Box display="grid" gap={16}>
                <FormikInput name="name" label={translate('vessel.name')} />
                {role.isSuperAdmin() ? (
                    <FormikInput name="imo" label={translate('vessel.imo')} />
                ) : (
                    <ReadOnlyField value={values.imo} label={translate('vessel.imo')} />
                )}

                <FormikInput name="email" label={translate('vessel.form.email')} markAsOptional />

                <FormikVesselDefaultSupplierFlow customerId={customerId} vesselId={vesselId} />
            </Box>

            <Box display="flex" flexDirection="column" gap={16}>
                <Text variant="subtitle1">{translate('vessel.form.invoiceInformation')}</Text>

                <FormikInput
                    name="invoiceAddress.companyName"
                    label={translate('global.address.company')}
                    autoComplete="organization"
                />
                <FormikInput name="vatNumber" label={translate('vessel.form.vat')} markAsOptional />
                <FormikInput
                    name="invoiceEmailAddress"
                    label={translate('vessel.form.invoiceEmailAddress')}
                    markAsOptional
                />

                <Box display="flex" flexDirection="column" gap={8}>
                    <FormikInput
                        name={'invoiceAddress.street'}
                        placeholder={translate('vessel.form.streetName')}
                        label={translate('vessel.form.billingAddress')}
                        autoComplete="street-address"
                    />
                    <FormikInput
                        name={'invoiceAddress.streetNumber'}
                        placeholder={translate('vessel.form.streetNumber')}
                    />
                    <FormikInput
                        name={'invoiceAddress.zipcode'}
                        placeholder={translate('vessel.form.postalCode')}
                        autoComplete="postal-code"
                    />
                    <FormikInput
                        name={'invoiceAddress.city'}
                        placeholder={translate('vessel.form.townCity')}
                        autoComplete="city"
                    />
                    <FormikInput
                        name={'invoiceAddress.country'}
                        placeholder={translate('global.address.country')}
                        autoComplete="country"
                    />
                </Box>
            </Box>

            <Box display="flex" flexDirection="column" gap={16}>
                <Text variant="subtitle1">{translate('vessel.form.postalAddress')}</Text>

                <FormikInput
                    name="postalAddress.companyName"
                    label={translate('global.address.company.optional')}
                    markAsOptional
                />

                <Box display="flex" flexDirection="column" gap={8}>
                    <FormikInput
                        name="postalAddress.street"
                        placeholder={translate('vessel.form.streetName')}
                        label={translate('vessel.form.address.optional')}
                        markAsOptional
                    />
                    <FormikInput
                        name="postalAddress.streetNumber"
                        placeholder={translate('vessel.form.streetNumber')}
                    />
                    <FormikInput name="postalAddress.zipcode" placeholder={translate('vessel.form.postalCode')} />
                    <FormikInput name="postalAddress.city" placeholder={translate('vessel.form.townCity')} />
                    <FormikInput name="postalAddress.country" placeholder={translate('global.address.country')} />
                </Box>
            </Box>
        </>
    );
};
